import React, { useEffect, useState } from "react";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";

import "./App.css";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import CookieConsent from "./components/CookieConsent/CookieConsent";
import ScrollToTop from "./ui/ScrollToTop";
import Loader from "./components/Loader/Loader";
import { measureBundleSize, logBundleInfo } from "./utils/performance";

// B2B Authentication Provider
import { B2BAuthProvider } from "./components/B2B/B2BShared/B2BAuthContext/B2BAuthContext.tsx";
// Cultural Events Admin Authentication Provider
import { AdminAuthProvider } from "./components/CulturalEvents/context/AdminAuthContext";

// Route Configuration
import AppRouter from "./routes";

/**
 * Main App component
 * Provides global layout structure and routing
 */
function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Initialize performance monitoring
    measureBundleSize();
    logBundleInfo();

    // Simulate initial loading
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  // Show loader during initial app loading
  if (loading) {
    return <Loader />;
  }

  return (
    <ErrorBoundary>
      <B2BAuthProvider>
        <AdminAuthProvider>
          <div className="app-container">
            <Header />
            <div className="content">
              <ScrollToTop />
              <AppRouter />
            </div>
            <Footer />
            <CookieConsent />
          </div>
        </AdminAuthProvider>
      </B2BAuthProvider>
    </ErrorBoundary>
  );
}

export default App;
